import { Logger } from 'wdc-cube'
import { ValueProperty } from '../tcm_filter_manager'
import {
    FilterExtraCboScope,
    JunctionMode,
    KeywordOption,
    MultipleOptionStringKeywordFilterScope,
    MultipleOptionStringKeywordParcelFilterScope
} from '../tcm_scopes'
import { CboCodeFilter, MultipleStringKeywordFilter, NumberOperator } from '../tcm_service'
import { TcmPresenterForStringMultiSelectFilter } from './tcm_filter_presenter_for_string_multi_select'
import { TcmPresenterForFilterPane } from './tcm_presenter_filter_pane'

const LOG = Logger.get('TCM-CBOFilter')

export class TcmPresenterForCbo extends TcmPresenterForStringMultiSelectFilter {
    defaultIsFilterQuantidade = false

    constructor(
        owner: TcmPresenterForFilterPane,
        scope: MultipleOptionStringKeywordFilterScope,
        valueProperty: ValueProperty<MultipleStringKeywordFilter>,
        onSearch?: () => Promise<KeywordOption[]>
    ) {
        super(owner, scope, valueProperty, onSearch)
        this.acceptBlankValues = false
    }

    populateUsingValueProporty(isFilterQuantidade: boolean) {
        const oldDefaultIsFilterQuantidade = this.defaultIsFilterQuantidade
        try {
            this.scope.conjunction.length = 0
            this.scope.disjunction.length = 0

            for (const entry of this.valueProperty.values() as IterableIterator<CboCodeFilter>) {
                this.defaultIsFilterQuantidade = entry.isFilterQuantidade ?? isFilterQuantidade
                const entryScope = entry.mode === JunctionMode.AND ? this.addConjuntion() : this.addDisjuntion()
                entryScope.operator = entry.operator
                entryScope.value = entry.value ?? []
            }
        } finally {
            this.defaultIsFilterQuantidade = oldDefaultIsFilterQuantidade
        }
    }

    override addConjuntion(): MultipleOptionStringKeywordParcelFilterScope {
        const andScope = super.addConjuntion()
        andScope.extraPosition = 'end'
        const extraScope = new FilterExtraCboScope()
        extraScope.isFilterQuantidade = this.defaultIsFilterQuantidade
        extraScope.onChangeIsFiltroQuantidade = this.action(this.onChangeIsFiltroQuantidade.bind(this, extraScope))
        extraScope.onExtraOperatorChange = this.action(this.handleExtraOperatorChange.bind(this, extraScope))
        extraScope.onExtraValueChange = this.action(this.handleExtraValueChange.bind(this, extraScope))
        extraScope.onExtraClear = this.action(this.handleExtraClear.bind(this, extraScope))
        extraScope.update = this.update
        andScope.extra = extraScope
        return andScope
    }

    override addDisjuntion(): MultipleOptionStringKeywordParcelFilterScope {
        const orScope = super.addDisjuntion()
        orScope.extraPosition = 'end'
        const extraScope = new FilterExtraCboScope()
        extraScope.isFilterQuantidade = this.defaultIsFilterQuantidade
        extraScope.onChangeIsFiltroQuantidade = this.action(this.onChangeIsFiltroQuantidade.bind(this, extraScope))
        extraScope.onExtraOperatorChange = this.action(this.handleExtraOperatorChange.bind(this, extraScope))
        extraScope.onExtraValueChange = this.action(this.handleExtraValueChange.bind(this, extraScope))
        extraScope.onExtraClear = this.action(this.handleExtraClear.bind(this, extraScope))
        extraScope.update = this.update
        orScope.extra = extraScope
        return orScope
    }

    protected async onChangeIsFiltroQuantidade(domainScope: FilterExtraCboScope, value: boolean) {
        domainScope.isFilterQuantidade = value
        LOG.debug(`onChangeIsFiltroQuantidade(value=${value})`)
    }

    protected override populateWithExtraValues(
        filter: CboCodeFilter,
        parcelScope: MultipleOptionStringKeywordParcelFilterScope
    ) {
        if (parcelScope.extra) {
            const extraScope = parcelScope.extra as FilterExtraCboScope
            filter.isFilterQuantidade = extraScope.isFilterQuantidade
            filter.extraMode = extraScope.extraMode
            filter.extraOperator = extraScope.extraOperator
            filter.extraValue = extraScope.extraValue
            filter.extraTo = extraScope.extraTo
        }
        return filter
    }

    apply(filters: CboCodeFilter[] | null | undefined) {
        if (!filters || filters.length === 0) {
            return
        }

        filters.forEach((filter) => {
            if (!filter.value) {
                return
            }

            this.defaultIsFilterQuantidade = filter.isFilterQuantidade ?? this.defaultIsFilterQuantidade

            let itemScope: MultipleOptionStringKeywordParcelFilterScope
            if (filter.mode === JunctionMode.AND) {
                itemScope = this.addConjuntion()
            } else {
                itemScope = this.addDisjuntion()
            }

            itemScope.value = filter.value ?? ''
            itemScope.operator = filter.operator
        })
    }

    private async handleExtraClear(parcelScope: FilterExtraCboScope) {
        parcelScope.extraTo = undefined
        parcelScope.extraValue = undefined
        parcelScope.isFilterQuantidade = false
    }

    private async handleExtraOperatorChange(parcelScope: FilterExtraCboScope, value: NumberOperator) {
        parcelScope.extraOperator = value
    }

    private async handleExtraValueChange(parcelScope: FilterExtraCboScope, value: string, source: 'from' | 'to') {
        if (source === 'from') {
            parcelScope.extraValue = value
        } else {
            parcelScope.extraTo = value
        }
    }
}
